var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"lg","variant":"secondary"}},[_c('b-navbar-brand',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.titulo))]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }